<template>
  <div @click="detailpage(params.value)">
    <span class="ml-2">
      <u class="cursor-pointer font-bold">
        <router-link style="color: #1A3683 !important;" :to="PathUrl">
          ดูรายละเอียด
        </router-link>
      </u>
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  methods: {
    async detailpage(e) {
      console.log(e);
      // this.$store.dispatch("general/saveurl",params.value)
    }
  },
  computed: {
    ...mapGetters({
      pointer: "general/pointer"
    }),

    PathUrl() {
      switch (this.pointer) {
        case "curriculum":
          return (this.path = `/curriculum/${this.params.value}`);
        case "course":
          return (this.path = `/course/${this.params.value}`);
        case "lecturer":
          return (this.path = `/lecturer/${this.params.value}`);
        case "user":
          return (this.path = `/user/${this.params.value}`);
        default:
          break;
      }
    }
  },

  data() {
    return {
      path: null
    };
  }
};
</script>

<style lang="scss" scoped></style>
